import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { Spinner, useLocalizeMessage } from 'libs.nucleus';
import { TranslationWorkbenchContext } from 'libs.translation_workbench';
import { useIrbJobs } from '../../hooks/use_irb_jobs.hook';
import { EmptySection } from '../section_empty';
import { createStaticColumns, createDynamicColumns } from './column-definitions';
import { useStablePackages, useStableData, useStableTranslate } from './hooks';
import { MemoizedTable } from './table-component';
export const JobList = () => {
    const translate = useLocalizeMessage();
    const stableTranslate = useStableTranslate(translate);
    const { study } = useContext(TranslationWorkbenchContext);
    const { data: jobs, isLoading } = useIrbJobs();
    const packages = jobs?.packages ?? {};
    const stablePackages = useStablePackages(packages);
    const isPackageAvaialble = Object.keys(packages).length > 0;
    // Stable translate functions
    const stableTranslations = useMemo(() => {
        return {
            locales: stableTranslate('Locales'),
            studyVersion: stableTranslate('Study version'),
            options: stableTranslate('Options'),
            createdBy: stableTranslate('Created by'),
            creationDate: stableTranslate('Creation date'),
            status: stableTranslate('Status'),
            noCover: stableTranslate('No cover'),
            withoutClinicianInterviewClinros: stableTranslate('No Clinician Interview ClinROs'),
            noResults: stableTranslate('-'),
            tableNavigation: stableTranslate('Locale table navigation'),
        };
    }, [stableTranslate]);
    // Use stable data processing
    const data = useStableData(stablePackages, stableTranslations, stableTranslate, study);
    // Create stable columns
    const staticColumns = useMemo(() => createStaticColumns(stableTranslations), [stableTranslations]);
    const dynamicColumns = useMemo(() => createDynamicColumns(stableTranslations), [stableTranslations]);
    // Combine static and dynamic columns
    const columns = useMemo(() => [...staticColumns, ...dynamicColumns], [staticColumns, dynamicColumns]);
    if (isLoading) {
        return (_jsx("div", { className: 'flex items-center justify-center min-h-48 relative', children: _jsx(Spinner, {}) }));
    }
    if (!isPackageAvaialble) {
        return _jsx(EmptySection, { text: translate('Review packages will be listed here.') });
    }
    return (_jsx("div", { children: _jsx(MemoizedTable, { data: data, columns: columns, labelNoResults: stableTranslations.noResults, paginationNavigationScreenReaderLabel: stableTranslations.tableNavigation }) }));
};
